export default __webpack_public_path__ + "static/media/bear1.e493d40e.png";